<script>
import UserAvatar from '@components/user/user-avatar.vue'
import TheProfileMenuCard from '@components/layout/the-profile-menu-card.vue'
import { mapGetters } from 'vuex'
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'TheProfileDropdown',
  components: {
    UserAvatar,
    TheProfileMenuCard,
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      user: 'auth/currentUser',
      userFullName: 'auth/currentUserFullName',
      userEmail: 'auth/currentUserEmail',
      isLoggedIn: 'auth/isUserLoggedIn',
      isLoadingAuth: 'auth/isLoadingAuth',
      getClient: 'auth/getClient',
      getSelectedClients: 'client/getSelectedClients',
    }),
    compTitle() {
      if (this.isImpersonating)
        return `${this.$t('impersonate.barText')} ${this.userFullName}`

      return this.$t('layout.profileDropdownLoggedInTooltipText', {
        name: this.userFullName,
      })
    },
    compFullName() {
      return (
        this.userFullName || this.$t('layout.profileDropdownDefaultUserName')
      )
    },
    compSelectedClientsText() {
      if (this.getSelectedClients.length === 1) {
        const client = this.getClient(this.getSelectedClients[0])
        return client?.clientName || 'Unknown'
      }

      return `${this.getSelectedClients.length} Selected`
    },
  },
}
</script>

<template>
  <div v-if="isLoggedIn">
    <v-menu
      bottom
      close-on-click
      :close-on-content-click="false"
      :nudge-width="150"
      nudge-bottom
      offset-y
      max-width="400"
    >
      <template v-slot:activator="{ on: menu }">
        <v-list
          id="menu-user-profile-dropdown-btn"
          :title="compTitle"
          class="py-0 d-xl d-lg transparent"
          :width="$vuetify.breakpoint.mdAndUp ? '280px' : ''"
          height="72"
        >
          <v-list-item class="profile-dropdown__list-item" v-on="{ ...menu }">
            <v-list-item-avatar
              class="overflow-visible"
              :class="[$mq === 'sm' || $mq === 'xs' ? 'pl-0 ml-0' : '']"
            >
              <UserAvatar
                size="md"
                :name="userFullName"
                :badge="isImpersonating"
                badge-color="blue"
                badge-dot
                badge-offset-x="10"
                badge-offset-y="10"
              />
            </v-list-item-avatar>

            <v-list-item-content v-if="$vuetify.breakpoint.mdAndUp">
              <v-list-item-title class="body-2">
                {{ compFullName }}
              </v-list-item-title>
              <v-list-item-subtitle
                v-if="getSelectedClients.length > 0"
                class="caption"
              >
                {{ compSelectedClientsText }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action
              :class="[$mq === 'sm' || $mq === 'xs' ? 'pl-0 ml-0' : '']"
            >
              <v-icon small>mdi-chevron-down</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>

      <TheProfileMenuCard id="menu-user-settings" />
    </v-menu>
  </div>
</template>

<style lang="scss" scoped>
.profile-dropdown__list-item {
  height: 72px !important;
}
</style>
